import React from "react";
import { useTranslation } from "react-i18next";
import { isRtlLanguage } from "../../utils/i18n";
import { useLocalizedCategories } from "../../hooks/useLocalizedCategories";
import "../categories/buttomG.css";

function ProductFilters({ categories, activeCategorySlug, onChange }) {
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const localizedCategories = useLocalizedCategories(categories);

  const visibleCategories = localizedCategories.filter(
    (category) => category.slug !== "uncategorized",
  );

  if (!visibleCategories.length) return null;

  return (
    <div
      className="gallery-tabs mb-6 flex gap-2 overflow-x-auto pb-2 sm:mb-8 sm:flex-wrap sm:justify-center sm:gap-3 sm:overflow-visible lg:flex-nowrap"
      role="tablist"
      aria-label={t("Products")}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <button
        type="button"
        role="tab"
        aria-selected={!activeCategorySlug}
        className={`gallery-tab b shrink-0 rounded-border px-3 py-2 text-xs font-normal transition-colors sm:px-4 sm:py-3 sm:text-sm md:text-base ${
          !activeCategorySlug ? "is-active" : ""
        }`}
        onClick={() => onChange(null)}
      >
        {t("All Products")}
      </button>
      {visibleCategories.map((category) => {
        const isActive = activeCategorySlug === category.slug;
        return (
          <button
            key={category.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`gallery-tab b shrink-0 rounded-border px-3 py-2 text-xs font-normal transition-colors sm:px-4 sm:py-3 sm:text-sm md:text-base ${
              isActive ? "is-active" : ""
            }`}
            onClick={() => onChange(category)}
          >
            {category.name}
          </button>
        );
      })}
    </div>
  );
}

export default ProductFilters;
